import { post } from 'communication/httpClient';
import { LOAD_CULTURES, CULTURES_LOADED, SYNC_FAILED, RESET_CULTURES } from './actionTypes';

export const initialActionsState = {
  loadCultures: () => {},
  resetCultures: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadCultures: async () => {
    dispatch({
      type: LOAD_CULTURES,
    });

    const { data, error } = await post('/api/culture', {});

    if (data) {
      dispatch({
        type: CULTURES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetCultures: () =>
    dispatch({
      type: RESET_CULTURES,
    }),
});
